import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SERVICES,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';

import { attachmentsOrigins } from '../../domains/attachments/constants';
import { ApiRequestDescriptor } from '../../services';

const { EXTERNAL_CARRIER_LABEL_ATTACHMENT } = attachmentsOrigins;

const EXTERNAL_CARRIER_LABEL_ENDPOINT =
  `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/externalCarrierDepositLabels`;
const FILE_ATTACHMENT_ENDPOINT =
  `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/${COMMON_QUERY_PARAMS.SERVICE}-attachments`;

export interface SetFileAttachmentInfoTransitionInfo {
  moduleDefinitionId?: string;
  moduleId?: string;
  wave?: number;
}

export interface SetFileAttachmentInfoRequestArgs {
  fileId: string;
  extension?: string;
  name?: string;
  fileAttachmentId: string;
  service?: string;
  transitionInfo?: SetFileAttachmentInfoTransitionInfo;
  type?: string;
}

export const setFileAttachmentInfoRequest = ({
  fileId,
  extension,
  name,
  fileAttachmentId,
  service,
  transitionInfo,
  type,
}: SetFileAttachmentInfoRequestArgs): ApiRequestDescriptor => {
  if (type === EXTERNAL_CARRIER_LABEL_ATTACHMENT) {
    return {
      url: EXTERNAL_CARRIER_LABEL_ENDPOINT.replace(
        COMMON_QUERY_PARAMS.FILE_ID,
        fileId,
      ),
      config: {
        method: SUPPORTED_METHODS.POST,
        json: {
          moduleDefinitionId: transitionInfo?.moduleDefinitionId,
          moduleInstanceId: transitionInfo?.moduleId,
          wave: transitionInfo?.wave,
          attachmentId: fileAttachmentId,
        },
      },
    };
  }

  return {
    url: FILE_ATTACHMENT_ENDPOINT.replace(
      COMMON_QUERY_PARAMS.FILE_ID,
      fileId,
    ).replace(COMMON_QUERY_PARAMS.SERVICE, service || SERVICES.MYACCOUNT),
    config: {
      method: SUPPORTED_METHODS.POST,
      json: {
        fileAttachmentId,
        name,
        extension,
        transitionInfo,
      },
    },
  };
};
